export const setGeneral = ({ commit }, payload) => {
  commit('SET_GENERAL', payload)
}

export const setGeneralLoading = ({ commit }, payload) => {
  commit('SET_GENERAL_LOADING', payload)
}
